import { render, staticRenderFns } from "./GroupsInfo.vue?vue&type=template&id=b97053d8&scoped=true"
import script from "./GroupsInfo.vue?vue&type=script&lang=js"
export * from "./GroupsInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupsInfo.vue?vue&type=style&index=0&id=b97053d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97053d8",
  null
  
)

export default component.exports